import { render, staticRenderFns } from "./MenuWindow.vue?vue&type=template&id=b10fd66a&scoped=true&"
import script from "./MenuWindow.vue?vue&type=script&lang=ts&"
export * from "./MenuWindow.vue?vue&type=script&lang=ts&"
import style0 from "./MenuWindow.vue?vue&type=style&index=0&id=b10fd66a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10fd66a",
  null
  
)

export default component.exports